import { useEffect, useState } from "react";
import Styles from "./themes.module.css";

import { useNavigate } from "react-router";
import { usePortal, useTestStore } from "../../../hooks/store";
import { getThemeList } from "../../../utils/API/biletMethod";
import { ExamCard } from "../../../components/ExamCard/ExamCard";
import { testType } from "../../../utils/testHelper";

export function Themes() {
  const [themeList, setThemeList] = useState([]);
  const nav = useNavigate();
  const testStore = useTestStore();
  const LoadingPortal = usePortal();
  useEffect(() => {
    LoadingPortal.setPortal();
    const getPageData = async () => {
      return await getThemeList();
    };

    getPageData().then(({ data }) => {
      setThemeList(data);
      LoadingPortal.closePortal();
    });
  }, []);

  const navToSolve = (thmeId, title, questionCount) => {
    nav(
      `../test?testType=${testType.theme.type}&id=${thmeId}&title=${title}&questions=${questionCount}`
    );
    testStore.setBaseData(
      {
        type: testType.theme.type,
        conditions: {
          ...testType.theme.conditions,
          questionCount: testType.theme.conditions.getquestionCount(
            questionCount,
            title
          ),
        },
      },
      title,
      thmeId
    );
  };

  return (
    <div className={Styles.theme_grid}>
      {themeList.map((theme) => {
        const { name, theme_number, id, question_count, subtheme, solved } =
          theme;

        return subtheme.length == 0 ? (
          <ExamCard
            type={testType.theme.type}
            key={id}
            size={1}
            title={`${theme_number}. ${name}`}
            questions={question_count}
            solved={solved}
            onClick={() =>
              navToSolve(id, `${theme_number}. ${name}`, question_count)
            }
            themeId={id}
          />
        ) : (
          subtheme.map((sub) => {
            const { name, theme_subnumber, id, question_count, solved } = sub;
            return (
              <ExamCard
                type={testType.theme.type}
                size={1}
                title={`${theme_number}.${theme_subnumber}. ${name}`}
                questions={question_count}
                solved={solved}
                themeId={id}
                onClick={() =>
                  navToSolve(
                    id,
                    `${theme_number}.${theme_subnumber}. ${name}`,
                    question_count
                  )
                }
              />
            );
          })
        );
      })}
    </div>
    // <Grid container spacing={3} columns={2}>

    // </Grid>
  );
}
